import React from 'react'
import ViewButton from '../../buttons/ViewButton'

const viewButton = ({ rowData, navigateTo }) => {
  return (
    <div key={rowData?._id}>
      <ViewButton
        onClick={() => navigateTo(rowData?._id, { state: { isEdit: false } })}
      />
    </div>
  )
}

const rowViewNavigatePath = ({ navigateTo }) => {
  return {
    className: 'row-delete',
    rowEditor: 'rowEditor',
    body: (rowData) => viewButton({ rowData, navigateTo }),
    exportable: false,
  }
}

export default rowViewNavigatePath
